// Shared client-side upload size cap. This is a UX guard only; the backend
// enforces its own limit. Deliberately-different limits (e.g. the seat-map JSON
// and business logo) keep their own local constants.
export const MAX_UPLOAD_MB = 15;
export const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;
